"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getParagraphSpacerTokens = require("./getParagraphSpacerTokens");

var _getParagraphSpacerTokens2 = _interopRequireDefault(_getParagraphSpacerTokens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isBetweenParagraphs = function isBetweenParagraphs(previousToken, currentToken) {
    return currentToken.type === "paragraph_open" && previousToken.type == "paragraph_close";
};

var injectParagraphSpacesIntoTokens = function injectParagraphSpacesIntoTokens(tokens) {
    if (!tokens || !tokens.length) return tokens;

    var handledTokens = [];
    handledTokens.push(tokens[0]);
    tokens.slice(1).forEach(function (token) {
        if (isBetweenParagraphs(handledTokens[handledTokens.length - 1], token)) {
            handledTokens.push.apply(handledTokens, _toConsumableArray((0, _getParagraphSpacerTokens2.default)()));
        }
        token.children = injectParagraphSpacesIntoTokens(token.children);
        handledTokens.push(token);
    });

    return handledTokens;
};

exports.default = injectParagraphSpacesIntoTokens;